import $script from 'scriptjs'

export default function () {
  return new Promise((resolve, reject) => {
    $script('https://api-maps.yandex.ru/2.1/?lang=ru_RU', () => {
      const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))
      const getYmaps = () => new Promise((resolve, reject) => window.ymaps ? resolve(window.ymaps) : reject(new Error('ymaps is not defined')))
      const retry = (fn, retries = 5, delay = 100) => {
        function recurse (i) {
          return fn().catch((e) => {
            if (i < retries) {
              return sleep(delay).then(() => recurse(++i))
            }
            throw e
          })
        }

        return recurse(0)
      }

      const result = retry(getYmaps)
        .then((ymaps) => new Promise(resolve => ymaps.ready(() => resolve(ymaps))))

      resolve(result)
    })
  })
}



// WEBPACK FOOTER //
// ./resources/assets/js/ymap.js